import { useState, useEffect } from "react";
import cx from "classnames";
import styles from "./Select.module.scss";
import Select, { components } from "react-select";
import Loader from "../Loader";
import CaretDown from "../CaretDown";

const Control = ({ children, ...props }) => (
  <components.Control {...props} className={styles.CustomControl}>
    {children}
  </components.Control>
);

const Menu = ({ children, ...props }) => (
  <components.Menu {...props} className={styles.CustomMenu}>
    {children}
  </components.Menu>
);

const MenuList = ({ children, ...props }) => (
  <components.MenuList {...props} className={styles.CustomMenuList}>
    {children}
  </components.MenuList>
);

const Placeholder = ({ children, ...props }) => (
  <div className={styles.CustomPlaceholderWrapper}>
    <DropdownIndicator />
    <components.Placeholder {...props} className={styles.CustomPlaceholder}>
      {children}
    </components.Placeholder>
  </div>
);

const Option = ({ children, ...props }) => (
  <components.Option
    {...props}
    className={cx(
      styles.CustomOption,
      props.isSelected ? styles.CustomOptionSelected : null,
      props.isFocused ? styles.CustomOptionFocused : null,
    )}>
    <div className={styles.SelectOption}>
      <div className={styles.SelectOptionImageContainer}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={props?.data?.icon} alt="logo" />
      </div>
      <span className={styles.SelectOptionId}>{props?.data?.value}</span>
      <span className={styles.SelectOptionLabel}>{props?.data?.label}</span>
    </div>
  </components.Option>
);

const SingleValue = ({ children, ...props }) => (
  <div className={styles.SingleValue}>
    <div className={styles.SingleValueImageContainer}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={props?.data?.icon} alt="logo" />
    </div>
    <components.SingleValue {...props} className={styles.CustomSingleValue}>
      {children}
    </components.SingleValue>
  </div>
);

const DropdownMenu = (props) => {
  return <div className={styles.DropdownMenu} {...props} />;
};
const Blanket = (props) => <div className={styles.Blanket} {...props} />;
const Dropdown = ({ children, isOpen, target, onClose, className }) => (
  <div className={cx(className, styles.DropdownWrapper)}>
    {target}
    {isOpen ? <DropdownMenu>{children}</DropdownMenu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);

// eslint-disable-next-line @next/next/no-img-element
const DropdownIndicator = () => <img src="../icon_search.svg" alt="logo" />;

const SelectComponent = ({
  name,
  handleChange,
  className,
  value = "",
  options,
  isGrouped = false,
  isLoading = false,
}) => {
  const [state, setState] = useState({
    isOpen: false,
    selectedItem: null,
    finalOptions: [],
  });
  const { isOpen, selectedItem, finalOptions } = state;
  const toggleOpen = () => {
    setState((prevState) => ({ ...prevState, isOpen: !prevState.isOpen }));
  };

  const updateSelectedItem = () => {
    if (isGrouped) {
      setState((prevState) => ({
        ...prevState,
        selectedItem:
          Object.keys(prevState.finalOptions)
            ?.map((category) => prevState.finalOptions[category]?.options || [])
            ?.flat()
            ?.find((option) => option.value === value) ?? null,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        selectedItem: prevState.finalOptions?.find(
          (option) => option.value === value,
        ),
      }));
    }
  };
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      finalOptions: isGrouped
        ? Object.keys(options)?.map((category) => ({
            ...options[category],
          }))
        : options,
    }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, options]);

  useEffect(() => {
    updateSelectedItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, finalOptions]);

  const onChange = (value) => {
    toggleOpen();
    handleChange(name, value?.value);
  };

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={toggleOpen}
      className={cx(className)}
      target={
        <button
          onClick={toggleOpen}
          className={cx(
            styles.SelectButton,
            isOpen ? styles.SelectButtonOpened : null,
          )}>
          {isLoading ? (
            <Loader className={styles.SelectLoader} />
          ) : (
            <>
              {selectedItem?.icon && (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  className={styles.SelectButtonImage}
                  src={selectedItem.icon}
                  height="16"
                  alt="icon"
                />
              )}
              <span className={styles.SelectButtonId}>
                {selectedItem?.value}
              </span>
              <span className={styles.SelectButtonLabel}>
                {selectedItem?.label}
              </span>
              <CaretDown className={styles.CaretDown} />
            </>
          )}
        </button>
      }>
      <Select
        components={{
          DropdownIndicator: null,
          IndicatorSeparator: null,
          Option,
          SingleValue,
          Control,
          Menu,
          MenuList,
          Placeholder,
        }}
        className={styles.SelectContainer}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        menuIsOpen
        placeholder="Search..."
        tabSelectsValue={false}
        isClearable={false}
        backspaceRemovesValue={false}
        value={selectedItem}
        isLoading={isLoading}
        options={finalOptions}
        onChange={onChange}
      />
    </Dropdown>
  );
};

export default SelectComponent;
